import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import LegalConsentField from './LegalConsentField';
export const renderLegalConsentField = (legalConsent)=>/*#__PURE__*/ _jsx(LegalConsentField, {
        legalConsent: legalConsent
    }, legalConsent.legalConsentId);
